
import React,{useState,useEffect} from 'react'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { Singleton } from '../../../js/Singleton';
import DialingLogPreview from '../Others/DialingLogPreview';
import ContainerDataPreview from '../Others/ContainerDataPreview';
import { UncontrolledTooltip } from 'reactstrap';
import { RECORD_STATE } from '../../../constants';
import { useSelector } from 'react-redux';

const sharedData=new SingletonSharedData();
const language= new Singleton();

const DataAndLog = ({showOnlyData,showDataLogDisp,onChange}) => {
  const [showLog,setShowLog]= useState(false);
  const [newData, setNewData] = useState({});
  const [disableInput,setDisableInput] = useState(false);
  const [showInformation, setShowInformation] = useState(false);
  const [showContainerDataPreview,setShowContainerDataPreview] = useState(false);
  const { selectedRecord, permissionUpdate ,selectedRecord:{data,headers,callKey,callOutId,camId,status} } = useSelector(state => state.preview);
  useEffect(() => {
    if(Object.keys(newData).length > 0){
      onChange && onChange(newData);
    }
  }, [newData])
  useEffect(() => {
    setShowLog(false)
  }, [selectedRecord])
  
  useEffect(() => {
    if((status === RECORD_STATE.DIALOG || status === RECORD_STATE.WRAPUP || status === RECORD_STATE.ALERT 
      || status === RECORD_STATE.ABANDONED) && permissionUpdate)
    {
      setDisableInput(false)
    }
    else{
      setDisableInput(true)
    }
  }, [status])

  useEffect(() => {
    callOutId !== 0 ? setShowInformation(true) : setShowInformation(false)
    showContainerDataP()
  }, [callOutId,status])
  
  const showContainerDataP = () =>{
    setShowContainerDataPreview(false);
    setTimeout(() => {
      setShowContainerDataPreview(true)
    }, 1);
  }
  if(showInformation){
    return (
      <div className= {`dal-container ${showOnlyData ? 'showOnlyData': ''} ${showDataLogDisp ? 'showDataLogDisp' : ''} ${status === RECORD_STATE.DIALOG ? 'showButtonOnDialog' : ''}`}>
        {showContainerDataPreview && <ContainerDataPreview
             showOnlyData={showOnlyData}
             userState={status}
             data={data}
             headers={headers}
             callKey={callKey}
             callOutId={callOutId}
             camId={camId}
             showLog={showLog}
             setShowLog={setShowLog}
             onChangeData={setNewData}
             disableInput={disableInput}
             />}
      
        {showLog && 
          <div className='dal-containerLog'>
            <div className='dal-container-log' >
              <i className='gcl-icon history' id='dal-btn-LogRec' onClick={() =>  setShowLog(!showLog)}/>
              <UncontrolledTooltip innerClassName='dal-tooltip-log' placement='top' target='dal-btn-LogRec' boundariesElement='window'>{language.getText('GUIPreviewdialingLogBtn')}</UncontrolledTooltip>
            </div>
            <DialingLogPreview 
              callOutId={callOutId} 
              camId={camId}  
              userId={sharedData.getParameters().UserID}
              showDataLogDisp={showDataLogDisp}
              status={status}
              showOnlyData={showOnlyData}
            />
          </div>
        } 
      </div>    
    )
  }
  return null;
}

export default DataAndLog


// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/DataAndLog.jsx